<template>
  <div class="merp-page">
    <section class="banner-section">
      <div class="container">
        <div class="row">
          <div class="col-sm pt-5">
            <div class="pt-5">
              <h1>matsMonit</h1>
              <p>Simple project monitoring of material usages.</p>
              <router-link to="/contact" class="btn btn-outline-secondary">Schedule a Demo</router-link>
              <!-- <a href="https://mats-monit.codehit.net" target="_blank" class="btn btn-outline-secondary ml-3">View App</a> -->
            </div>
          </div>
          <div class="col-sm-6">
            <div class="pt-5">
              <a href="/img/mats-monit.png" data-fancybox="mats-monit-images">
                <div class="merp-banner">
                  <img src="/img/mats-monit.png" alt="actMonit" class="img-fluid">
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <section>
        <h3 class="mt-5">Screenshots</h3>
        <div class="row text-center">
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/mats-monit/1.png" data-fancybox="mats-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/mats-monit/1.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/mats-monit/2.png" data-fancybox="mats-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/mats-monit/2.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/mats-monit/3.png" data-fancybox="mats-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/mats-monit/3.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/mats-monit/4.png" data-fancybox="mats-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/mats-monit/4.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/mats-monit/5.png" data-fancybox="mats-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/mats-monit/5.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/mats-monit/6.png" data-fancybox="mats-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/mats-monit/6.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/mats-monit/7.png" data-fancybox="mats-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/mats-monit/7.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/mats-monit/8.png" data-fancybox="mats-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/mats-monit/8.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
  </div>
</template>

<script>

import Footer from '@/components/Footer.vue'

export default {
  name: 'ActMonit',
  components: {
    Footer
  }
}
</script>

<style lang="scss">
  .banner-section {
    background:#f8f9fa url('/img/cityscape.png') no-repeat center bottom;
  }
  .merp-banner {
    overflow: hidden;
    height: 350px;
    text-align: center;
    box-shadow: -2px 2px 7px -1px rgba(0,0,0,0.2);
  }
</style>